export const newsHeroSubtitle = 'Announcements';
export const newsHeroTitle = 'Notice';
export const newsHeroDescription = 'Check SALTED\'s important announcements';

// Tabs
export const tabArticles = 'Articles';
export const tabNotice = 'Notice';
export const tabEvents = 'Events';

// Search
export const searchTypeTitle = 'Title';
export const searchTypeContent = 'Content';
export const searchPlaceholder = 'Enter search term';
export const searchButton = 'Search';
export const resetButton = 'Reset';

// Table Headers
export const tableHeaderNumber = 'No.';
export const tableHeaderTitle = 'Title';
export const tableHeaderAuthor = 'Author';
export const tableHeaderDate = 'Date';
export const tableHeaderViews = 'Views';

// Messages
export const noResults = 'No search results found.';
export const loading = 'Loading...';

export default {
  newsHeroSubtitle,
  newsHeroTitle,
  newsHeroDescription,
  tabArticles,
  tabNotice,
  tabEvents,
  searchTypeTitle,
  searchTypeContent,
  searchPlaceholder,
  searchButton,
  resetButton,
  tableHeaderNumber,
  tableHeaderTitle,
  tableHeaderAuthor,
  tableHeaderDate,
  tableHeaderViews,
  noResults,
  loading
};